import { BreakPointHooks } from 'Hooks/BreakPointHooks';

import { IDynamicCreativeBlockViewModel } from 'Types/Litium';
import CreativeItem from 'Components/Creative/CreativeItem';

const { useGreater } = BreakPointHooks();

interface DynamicCreativeBlockViewModel extends IDynamicCreativeBlockViewModel {
    shouldLazyLoad?: boolean;
}

const Creative = (props: DynamicCreativeBlockViewModel) => {
    const {
        backgroundColor,
        marginBewteenColumns,
        marginBetweenColumnsMobile,
        creativeItems,
        shouldLazyLoad = false,
        translations,
        reverseBlockOrderMobile,
    } = props;

    const isGreater = useGreater('lg');

    const desktopColumnsDisposition = creativeItems
        .map(struc => `minmax(0, ${struc.columnSpan || 1}fr)`)
        .join(' ');

    const totalColumnSpan = creativeItems.reduce(
        (acc, struc) => acc + (struc.columnSpan || 1),
        0
    );

    const columnsDisposition =
        creativeItems.length > 3 ? 'repeat(2, minmax(0, 1fr))' : '1fr';

    const mobileFullWidthItem = (index: number) =>
        creativeItems.length < 4 ||
        (creativeItems.length > 4 &&
            creativeItems.length % 2 &&
            index === creativeItems.length - 1);

    const determineMobileTextDisposition = (index: number) =>
        creativeItems.length > 3 &&
        (creativeItems.length % 2 === 0 || index !== creativeItems.length - 1);

    return (
        <div
            style={
                {
                    '--background-color': backgroundColor,
                    '--grid-template-columns-desktop':
                        creativeItems.length > 0
                            ? desktopColumnsDisposition
                            : '1fr',
                    '--grid-template-columns':
                        creativeItems.length > 0 ? columnsDisposition : '1fr',
                    '--block-margin-desktop': `${marginBewteenColumns}px`,
                    '--block-margin': `${marginBetweenColumnsMobile}px`,
                } as React.CSSProperties
            }
            className="grid h-auto grid-cols-[var(--grid-template-columns)] gap-[var(--block-margin)] bg-[var(--background-color)] p-[var(--block-margin)] lg:grid-cols-[var(--grid-template-columns-desktop)] lg:gap-[var(--block-margin-desktop)] lg:p-[var(--block-margin-desktop)]"
        >
            {creativeItems.map((item, index) => (
                <CreativeItem
                    key={index}
                    item={item}
                    isGreater={isGreater}
                    mobileFullWidthItem={mobileFullWidthItem(index)}
                    mobileCenterText={determineMobileTextDisposition(index)}
                    totalColumns={totalColumnSpan}
                    shouldLazyLoad={shouldLazyLoad}
                    translations={translations}
                    reverseBlockOrderMobile={reverseBlockOrderMobile}
                    index={index}
                />
            ))}
        </div>
    );
};

export default Creative;
